import { useParams } from 'react-router';
import { useAuth } from '@/features/auth/use-auth';
import { ConserjeDashboard } from '@/features/visitas/conserje-dashboard';
import { MyPasses } from '@/features/visitas/my-passes';

export function VisitasRoute() {
  const { session } = useAuth();
  // condoId from URL — always present inside TenantShell (/app/condominios/:condoId/*)
  const { condoId } = useParams<{ condoId?: string }>();
  if (!session) return null;
  if (session.isSuperAdmin) return <ConserjeDashboard />;
  const effectiveRol = condoId ? session.tenants[condoId] : undefined;
  if (effectiveRol === 'conserje' || effectiveRol === 'admin') {
    return <ConserjeDashboard />;
  }
  return <MyPasses />;
}
